import { useQuery } from '@tanstack/react-query'
import type { SharableOpportunitiesQuery, SharableOpportunitiesResponse } from 'backend/types'
import { getSharableOpportunities } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseSharableOpportunitiesOptions {
  query?: Partial<SharableOpportunitiesQuery>
  enabled?: boolean // データ取得を有効化するか（デフォルト: true）
}

/**
 * 共有可能案件一覧を取得するカスタムフック
 *
 * @param options - フックオプション（クエリパラメータ、有効化フラグ）
 * @returns TanStack Query の結果（data, isLoading, error, refetch など）
 *
 * @example
 * ```tsx
 * const { data, isLoading, error, refetch } = useSharableOpportunities({
 *   query: { onlyRelease: true, limit: 10 }
 * })
 * ```
 */
export function useSharableOpportunities(options: UseSharableOpportunitiesOptions = {}) {
  const { query, enabled = true } = options

  // query オブジェクトの値を個別に取り出してクエリキーに使用
  const { onlyRelease, offset, limit } = query || {}

  return useQuery<SharableOpportunitiesResponse, Error>({
    queryKey: queryKeys.sharableOpportunities({ onlyRelease, offset, limit }),
    queryFn: async () => {
      return getSharableOpportunities({ onlyRelease, offset, limit })
    },
    enabled,
  })
}
